import { render, staticRenderFns } from "./FlashMessage.vue?vue&type=template&id=221d7999&scoped=true"
import script from "./FlashMessage.vue?vue&type=script&lang=ts"
export * from "./FlashMessage.vue?vue&type=script&lang=ts"
import style0 from "./FlashMessage.vue?vue&type=style&index=0&id=221d7999&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221d7999",
  null
  
)

export default component.exports